<template>
  <div class="toolbar">
  <div @click="openPanel('help')" class="toolbar-btn help" :class="panels.all.help ? 'active' : ''">
    <svg class="svg-icon"><use xlink:href="#svg-help" /></svg>
  </div>
  <div @click="openPanel('summary')" v-if="(! settings.infinityMode && stats.games) || (settings.infinityMode && stats.infinity.games)" class="toolbar-btn summary" :class="panels.all.summary ? 'active' : ''">
    <svg class="svg-icon"><use xlink:href="#svg-stats" /></svg>
  </div>
  <div @click="openPanel('settings')" class="toolbar-btn settings" :class="panels.all.settings ? 'active' : ''">
    <svg class="svg-icon"><use xlink:href="#svg-settings" /></svg>
  </div>

  <h1 class="app-title">
    WORDLE<span>·FR</span>
    <strong class="infinity" v-if="settings.infinityMode">mode INFINI !</strong>
  </h1>
  </div>
</template>

<script>
export default {
  name: 'ToolBar',
  props: {
    stats: Object,
    panels: Object,
    settings: Object,
  },
  methods: {
    openPanel: function (p) {
      this.$emit('openPanel', p)
    },
  }
}
</script>
